package com.tovtalk.domain.usecase.post

import com.tovtalk.domain.entity.DomainResult
import com.tovtalk.domain.repository.PostRepository

/**
 * View Post Use Case (v2)
 *
 * שולח ספירת צפייה לשרת
 */
class IncreaseViewCountUseCase(
    private val postRepository: PostRepository
) {
    suspend operator fun invoke(postId: Int): DomainResult<Unit> {
        return postRepository.viewPost(postId)
    }
}
